import { useEffect, useState } from "react"

export default function ProposedChanges(feilds) {
    const [updatedFeilds, setUpdatedFields] = useState({})
    // console.log({test: feilds['preferred_dap_brand']})
    const updated = () => {
        setUpdatedFields(
            {
                required_urea_quantity: {
                    requestedValue: feilds['required_urea_quantity'],
                    proposedValue: feilds['required_urea_quantity']
                },
                preferred_urea_brand: {
                    requestedValue: {
                        name: feilds['preferred_urea_brand']?.name,
                        logo: feilds['preferred_urea_brand']?.logo
                    },
                    proposedValue: {
                        name: feilds['preferred_urea_brand']?.name,
                        logo: feilds['preferred_urea_brand']?.logo
                    }
                },
                required_dap_quantity: {
                    requestedValue: feilds['required_dap_quantity'],
                    proposedValue: feilds['required_dap_quantity']
                },
                preferred_dap_brand: {
                    requestedValue: {
                        name: feilds['preferred_dap_brand']?.name,
                        logo: feilds['preferred_dap_brand']?.logo
                    },
                    proposedValue: {
                        name: feilds['preferred_dap_brand']?.name,
                        logo: feilds['preferred_dap_brand']?.logo
                    }
                },
                preferred_zinc_quantity: {
                    requestedValue: feilds['preferred_zinc_quantity'],
                    proposedValue: feilds['preferred_zinc_quantity']
                },
                preferred_zinc_brand: {
                    requestedValue: {
                        name: feilds['preferred_zinc_brand']?.name,
                        logo: feilds['preferred_zinc_brand']?.logo
                    },
                    proposedValue: {
                        name: feilds['preferred_zinc_brand']?.name,
                        logo: feilds['preferred_zinc_brand']?.logo
                    }
                },
                preferred_sop_quantity: {
                    requestedValue: feilds['preferred_sop_quantity'],
                    proposedValue: feilds['preferred_sop_quantity']
                },
                preferred_sop_brand: {
                    requestedValue: {
                        name: feilds['preferred_sop_brand']?.name,
                        logo: feilds['preferred_sop_brand']?.logo
                    },
                    proposedValue: {
                        name: feilds['preferred_sop_brand']?.name,
                        logo: feilds['preferred_sop_brand']?.logo
                    }
                },
                preferred_np_quantity: {
                    requestedValue: feilds['preferred_np_quantity'],
                    proposedValue: feilds['preferred_np_quantity']
                },
                preferred_np_brand: {
                    requestedValue: {
                        name: feilds['preferred_np_brand']?.name,
                        logo: feilds['preferred_np_brand']?.logo
                    },
                    proposedValue: {
                        name: feilds['preferred_np_brand']?.name,
                        logo: feilds['preferred_np_brand']?.logo
                    }
                },
                preferred_mop_quantity: {
                    requestedValue: feilds['preferred_mop_quantity'],
                    proposedValue: feilds['preferred_mop_quantity']
                },
                preferred_mop_brand: {
                    requestedValue: {
                        name: feilds['preferred_mop_brand']?.name,
                        logo: feilds['preferred_mop_brand']?.logo
                    },
                    proposedValue: {
                        name: feilds['preferred_mop_brand']?.name,
                        logo: feilds['preferred_mop_brand']?.logo
                    }
                },
                required_pesticides_quantity: {
                    requestedValue: feilds['required_pesticides_quantity'],
                    proposedValue: feilds['required_pesticides_quantity']
                },
                preferred_pesticides_brand: {
                    requestedValue: {
                        name: feilds['preferred_pesticides_brand']?.name,
                        logo: feilds['preferred_pesticides_brand']?.logo
                    },
                    proposedValue: {
                        name: feilds['preferred_pesticides_brand']?.name,
                        logo: feilds['preferred_pesticides_brand']?.logo
                    }
                },
                preferred_weedicide_quantity: {
                    requestedValue: feilds['preferred_weedicide_quantity'],
                    proposedValue: feilds['preferred_weedicide_quantity']
                },
                preferred_weedicide_brand: {
                    requestedValue: {
                        name: feilds['preferred_weedicide_brand']?.name,
                        logo: feilds['preferred_weedicide_brand']?.logo
                    },
                    proposedValue: {
                        name: feilds['preferred_weedicide_brand']?.name,
                        logo: feilds['preferred_weedicide_brand']?.logo
                    }
                },
                preferred_fungicide_quantity: {
                    requestedValue: feilds['preferred_fungicide_quantity'],
                    proposedValue: feilds['preferred_fungicide_quantity']
                },
                preferred_fungicide_brand: {
                    requestedValue: {
                        name: feilds['preferred_fungicide_brand']?.name,
                        logo: feilds['preferred_fungicide_brand']?.logo
                    },
                    proposedValue: {
                        name: feilds['preferred_fungicide_brand']?.name,
                        logo: feilds['preferred_fungicide_brand']?.logo
                    }
                },
                required_seeds_quantity_kgs: {
                    requestedValue: feilds['required_seeds_quantity_kgs'],
                    proposedValue: feilds['required_seeds_quantity_kgs']
                },
                preferred_seeds_company: {
                    requestedValue: {
                        name: feilds['preferred_seeds_company']?.name,
                        logo: feilds['preferred_seeds_company']?.logo
                    },
                    proposedValue: {
                        name: feilds['preferred_seeds_company']?.name,
                        logo: feilds['preferred_seeds_company']?.logo
                    }
                },
            }
        )
    }

    useEffect(() => {
        updated()
    }, [])
    // const proposedFeilds = updatedFeilds;

    return [updated, updatedFeilds, setUpdatedFields]
}
